// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__24Bfq","column":"style_column__2caeI","row":"style_row__2Ezsc"};